<template>
  <div>
    <div class="head-top"></div>
    <div
      class="head-top-fixed"
      :class="[{'head-f':headtopShow}]"
      style="background:#fff"
    >
      <div class="head-top">
        <header class="headroom">
          <div class="wrap clearfix">
            <h1 class="fl">
              <a
                href="#"
                tppabs="http://www.witfort.cn/"
                class="fl logo"
              >
                <img
                  src="@/image/logo.png"
                  alt="witfort"
                  width="441"
                  height="41"
                />
              </a>
            </h1>
            <div class="fr">
              <div class="top">
                <span class="call"></span>
                <span class="call_tel c_15909c">0755-36994096</span>
                <a
                  href="mailto:marketing@witfort.net"
                  class="c_888"
                >
                  <span class="email"></span>
                  marketing@witfort.net
                </a>
                <a class="ewm c_888">
                  <span class="weixin"></span>
                  二维码关注我们
                  <img
                    src="@/image/contact_weixin.jpg"
                    tppabs="@/image/contact_weixin.jpg"
                    width="258"
                    height="258"
                    alt="witfort微信"
                  />
                </a>
              </div>
              <nav class="nav">
                <ul
                  class="clearfix"
                  style="margin-right:-20px;"
                >

                  <li
                    @click="goNav(item.path)"
                    v-for="(item,index) in navList"
                    :key="index"
                    :class="[{'sel-LI':index==selindex},{'nosel':index!=selindex}]"
                  >
                    <!-- <span
                    class="li_span"
                    v-if="index==3"
                  >热</span> -->
                    {{item.name}}
                    <i
                      v-if="index==3"
                      class="li_span"
                    ></i>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </header>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "headtop",
  props: {
    selindex: {
      type: Number,
      default: 0,
    }
  },
  data () {
    return {
      headtopShow: false,
      navList: [
        { name: "智垒首页", path: "index" },
        { name: "关于我们", path: "about" },
        { name: "解决方案", path: "zlTravel" },
        { name: "定制客运", path: "cusKc" },
        { name: "成功案例", path: "stories" },
        { name: "服务流程", path: "process" },
        { name: "常见问题", path: "commonproblem" },
      ],
    };
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    goNav (name) {
      if (!name) return;
      this.$router.push({ name });
    },
    handleScroll () {
      //获取滚动时的高度
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop < 100 && this.headtopShow) {
        this.headtopShow = false
      }
      if (scrollTop > 100 && !this.headtopShow) {
        this.headtopShow = true
      }
    },
    destroyed () {
      document.removeEventListener('scroll', this.handleScroll)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>



// WEBPACK FOOTER //
// src/components/headtop/headtop.vue